var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "animated fadeIn"
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header -filter_main"
  }, [_c('label', [_vm._v("Update Invoice Details")])])])]), _vm._v(" "), _c('b-card', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmitSearch($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', [_c('label', [_vm._v("AWB")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "11px"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-shopping-cart'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.awb),
      expression: "awb"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('awb')
    },
    attrs: {
      "type": "text",
      "placeholder": "Please Enter AWB",
      "name": "awb",
      "id": "awb"
    },
    domProps: {
      "value": (_vm.awb)
    },
    on: {
      "keypress": function($event) {
        _vm.isIntegerOnly($event)
      },
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.validateAWB($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.awb = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('awb')),
      expression: "errors.has('awb')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter AWB No")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5",
    staticStyle: {
      "top": "-6px"
    }
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.validateAWB
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")]), _vm._v("   \n                            "), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reset")])])], 1)]), _vm._v(" "), (_vm.invoiceData.length > 0) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', [_c('label', [_vm._v("Comments")]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#449d42",
      "font-size": "11px"
    }
  }, [_vm._v("Note:Maximum Length 500 character")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comments),
      expression: "comments"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('comments')
    },
    attrs: {
      "name": "comments",
      "id": "comments",
      "placeholder": "Enter Comments"
    },
    domProps: {
      "value": (_vm.comments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comments = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.commentErr))])], 1)]) : _vm._e(), _vm._v(" "), _c('form', {
    attrs: {
      "data-vv-scope": "invoicegstdetailsform"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [(_vm.invoiceData.length > 0) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('b-form-fieldset', [_c('div', {
    staticStyle: {
      "overflow-y": "auto"
    }
  }, [_c('table', {
    staticClass: "styled-table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "invoicedetails"
    }
  }, [_c('thead', {
    staticClass: "th"
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "5%"
    }
  }, [_vm._v("Sr.No.")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Invoice Number")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("Invoice Value (INR)")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "25%"
    }
  }, [_vm._v("Is EWBN Exempted")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("EWB Number")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("EWB Expiry Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "5%"
    }
  }, [_vm._v("Action")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "5%"
    }
  }, [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.invoiceData), function(data, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('b-input-group', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form.InvoiceNumber[index]),
        expression: "form.InvoiceNumber[index]"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      class: {
        'form-control': true
      },
      attrs: {
        "tabindex": "16",
        "type": "text",
        "placeholder": "Invoice Number",
        "min": "0",
        "name": _vm.setname(index, 'InvoiceNumber'),
        "id": _vm.setname(index, 'InvoiceNumber')
      },
      domProps: {
        "value": (_vm.form.InvoiceNumber[index])
      },
      on: {
        "click": function($event) {
          _vm.clearValidateEwbFlag(index)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form.InvoiceNumber, index, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('invoicegstdetailsform.InvoiceNumber' + index)),
        expression: "errors.has('invoicegstdetailsform.InvoiceNumber'+index)"
      }],
      staticClass: "text-danger errormsg"
    }, [_vm._v("Invoice Number is required")])], 1), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('b-input-group', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form.InvoiceValue[index]),
        expression: "form.InvoiceValue[index]"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      class: {
        'form-control': true
      },
      attrs: {
        "tabindex": "17",
        "type": "text",
        "min": "0",
        "placeholder": "Invoice Value",
        "name": _vm.setname(index, 'InvoiceValue'),
        "id": _vm.setname(index, 'InvoiceValue')
      },
      domProps: {
        "value": (_vm.form.InvoiceValue[index])
      },
      on: {
        "keypress": function($event) {
          _vm.isNumber($event)
        },
        "click": function($event) {
          _vm.clearValidateEwbFlag(index)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form.InvoiceValue, index, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('invoicegstdetailsform.InvoiceValue' + index)),
        expression: "errors.has('invoicegstdetailsform.InvoiceValue'+index)"
      }],
      staticClass: "text-danger errormsg"
    }, [_vm._v("Invoice Value is required")])], 1), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('b-input-group', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form.IsEwbnExempted[index]),
        expression: "form.IsEwbnExempted[index]"
      }],
      class: {
        'form-control': true
      },
      staticStyle: {
        "margin": "auto"
      },
      attrs: {
        "type": "checkbox",
        "true-value": "1",
        "false-value": "0",
        "name": "IsEwbnExepmted",
        "id": _vm.setname(index, 'IsEwbnExempted'),
        "name": _vm.setname(index, 'IsEwbnExepmted')
      },
      domProps: {
        "checked": Array.isArray(_vm.form.IsEwbnExempted[index]) ? _vm._i(_vm.form.IsEwbnExempted[index], null) > -1 : _vm._q(_vm.form.IsEwbnExempted[index], "1")
      },
      on: {
        "click": function($event) {
          _vm.clearHSNCheckFlag(index)
        },
        "__c": function($event) {
          var $$a = _vm.form.IsEwbnExempted[index],
            $$el = $event.target,
            $$c = $$el.checked ? ("1") : ("0");
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.form.IsEwbnExempted[index] = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.form.IsEwbnExempted[index] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(_vm.form.IsEwbnExempted, index, $$c)
          }
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form.HsnCode[index]),
        expression: "form.HsnCode[index]"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: (("" + ((_vm.form.IsEwbnExempted[index]=='1')?'required':''))),
        expression: "`${(form.IsEwbnExempted[index]=='1')?'required':''}`"
      }],
      class: {
        'form-control': true
      },
      attrs: {
        "type": "text",
        "min": "0",
        "placeholder": "HSN",
        "name": _vm.setname(index, 'HsnCode'),
        "id": _vm.setname(index, 'HsnCode'),
        "disabled": _vm.form.IsEwbnExempted[index] != 1
      },
      domProps: {
        "value": (_vm.form.HsnCode[index])
      },
      on: {
        "keypress": function($event) {
          _vm.isNumber($event)
        },
        "click": function($event) {
          _vm.clearHSNFlag(index)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form.HsnCode, index, $event.target.value)
        }
      }
    }), _vm._v("   \n                                    "), _c('button', {
      staticClass: "fa fa-save",
      attrs: {
        "type": "button",
        "title": "Verify HSN",
        "name": "button",
        "disabled": _vm.form.IsEwbnExempted[index] != 1
      },
      on: {
        "click": function($event) {
          _vm.verifyHsnCode(index)
        }
      }
    })]), _vm._v(" "), (_vm.form.IsEwbnExempted[index] == 1 && _vm.form.ishsnverified[index] == '2') ? _c('span', {
      staticClass: "text-danger errormsg"
    }, [_vm._v("HSN Code Invalid")]) : _vm._e(), _vm._v(" "), (_vm.form.IsEwbnExempted[index] == 1 && _vm.form.ishsnverified[index] == '1') ? _c('span', {
      staticClass: "text-success errormsg"
    }, [_vm._v("HSN Code Verified")]) : _vm._e(), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('invoicegstdetailsform.HsnCode' + index)),
        expression: "errors.has('invoicegstdetailsform.HsnCode'+index)"
      }],
      staticClass: "text-danger errormsg"
    }, [_vm._v("HSN Code is required")])], 1), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('b-input-group', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form.EWBNumber[index]),
        expression: "form.EWBNumber[index]"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: (("" + ((_vm.form.InvoiceValue[index]>=_vm.EBNlimit) && (_vm.form.IsEwbnExempted[index]==0)?'required':''))),
        expression: "`${(form.InvoiceValue[index]>=EBNlimit) && (form.IsEwbnExempted[index]==0)?'required':''}`"
      }],
      class: {
        'form-control': true
      },
      attrs: {
        "type": "text",
        "placeholder": "EWB Number",
        "minlength": "12",
        "min": "0",
        "name": _vm.setname(index, 'EWBNumber'),
        "id": _vm.setname(index, 'EWBNumber')
      },
      domProps: {
        "value": (_vm.form.EWBNumber[index])
      },
      on: {
        "keypress": function($event) {
          _vm.isNumber($event)
        },
        "click": function($event) {
          _vm.clearValidateEwbFlag(index)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form.EWBNumber, index, $event.target.value)
        }
      }
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.form.IsEwbnExempted[index] == 0 && _vm.form.isvalid[index] == 1),
        expression: "form.IsEwbnExempted[index]==0 && form.isvalid[index]==1"
      }],
      staticClass: "fa fa-check fa-2x",
      staticStyle: {
        "color": "green"
      }
    }), _vm._v(" \n                                    "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.form.IsEwbnExempted[index] == 0 && _vm.form.isvalid[index] == 2),
        expression: "form.IsEwbnExempted[index]==0 && form.isvalid[index]==2"
      }],
      staticClass: "fa fa-close fa-2x",
      staticStyle: {
        "color": "red"
      }
    }), _vm._v(" \n                                    "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.form.IsEwbnExempted[index] == 0 && _vm.form.isvalid[index] == 1),
        expression: "form.IsEwbnExempted[index]==0 && form.isvalid[index]==1"
      }],
      staticClass: "fa fa-info-circle fa-2x",
      on: {
        "click": function($event) {
          _vm.openEBNInfoPopup(_vm.form.EWBResponse[index])
        }
      }
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.form.IsEwbnExempted[index] == 0 && _vm.form.isvalid[index] == 2),
        expression: "form.IsEwbnExempted[index]==0 && form.isvalid[index]==2"
      }],
      staticClass: "fa fa-info-circle fa-2x",
      on: {
        "click": function($event) {
          _vm.openErrorEBNInfoPopup(_vm.form.EWBResponse[index])
        }
      }
    })]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('invoicegstdetailsform.EWBNumber' + index)),
        expression: "errors.has('invoicegstdetailsform.EWBNumber'+index)"
      }],
      staticClass: "text-danger errormsg"
    }, [_vm._v("EWB Number is required and must be min 12 digits")])], 1), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.form.EWBExpiryDate[index]) + "\n                                ")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.form.IsEwbnExempted[index] != '1'),
        expression: "form.IsEwbnExempted[index]!='1'"
      }],
      staticClass: "-btn btn-success",
      attrs: {
        "type": "button",
        "title": "Validate EWB"
      },
      on: {
        "click": function($event) {
          _vm.validateEWB(index)
        }
      }
    }, [_vm._v("Validate EWB")])]), _vm._v(" "), _c('td', [((index + 1) <= _vm.invoiceData.length && _vm.invoiceData.length != 1) ? _c('i', {
      staticClass: "fa fa-trash fa-2x",
      staticStyle: {
        "color": "red",
        "cursor": "pointer"
      },
      attrs: {
        "title": "Delete"
      },
      on: {
        "click": function($event) {
          _vm.deleteRow(index)
        }
      }
    }) : _vm._e(), _vm._v(" "), ((index + 1) == _vm.invoiceData.length) ? _c('i', {
      staticClass: "fa fa-plus-circle fa-2x",
      staticStyle: {
        "color": "blue",
        "cursor": "pointer"
      },
      attrs: {
        "title": "Add New"
      },
      on: {
        "click": function($event) {
          _vm.addnewrow(index)
        }
      }
    }) : _vm._e()])])
  }))])])])], 1) : _vm._e()])]), _vm._v(" "), (_vm.invoiceData.length > 0) ? _c('div', [_c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button",
      "title": "Save"
    },
    on: {
      "click": _vm.saveInvoiceAndGSTDetails
    }
  }, [_vm._v("Save "), _c('i', {
    staticClass: "fa fa-save"
  })])])]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    on: {
      "ok": function($event) {
        _vm.EBNInfoPopup == false
      }
    },
    model: {
      value: (_vm.EBNInfoPopup),
      callback: function($$v) {
        _vm.EBNInfoPopup = $$v
      },
      expression: "EBNInfoPopup"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_c('label', [_c('strong', [_vm._v("Invoice Details ")])])]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close",
      "title": "Close"
    },
    on: {
      "click": _vm.closeEBNInfoPopup
    }
  }, [_vm._v("x")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "invoicedetails"
    }
  }, [_c('thead', {
    staticClass: "th"
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("HSN")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("GST %")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("CGST (INR)")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("SGST (INR)")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("IGST (INR)")])])]), _vm._v(" "), _vm._l((_vm.hsnlist), function(val, index) {
    return _c('tbody', [_c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(val.hsnCode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(val.GST))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(val.cgstRate))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(val.sgstRate))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(val.igstRate))])])])
  })], 2)])])])], 1)]), _vm._v(" "), _c('b-modal', {
    on: {
      "ok": function($event) {
        _vm.EBNInfoErrorPopup == false
      }
    },
    model: {
      value: (_vm.EBNInfoErrorPopup),
      callback: function($$v) {
        _vm.EBNInfoErrorPopup = $$v
      },
      expression: "EBNInfoErrorPopup"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_c('label', [_c('strong', [_vm._v("Error ")])])]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close",
      "title": "Close"
    },
    on: {
      "click": _vm.closeErrorEBNInfoPopup
    }
  }, [_vm._v("x")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('ol', {
    staticStyle: {
      "color": "#000"
    }
  }, _vm._l((_vm.ewbDetailsErrorList), function(val, index) {
    return _c('li', [_vm._v(_vm._s(val))])
  }))])])])], 1)])], 1)])])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d3e1880","hasScoped":true}!./src/modules/utility/views/updateInvoiceDetails/updateInvoiceDetails.component.html
// module id = 2133
// module chunks = 3